module.exports = __webpack_public_path__ + "img/blockables-instructions-0.3a0b9a81.png";